export default __webpack_public_path__ + "assets/images/43568efda8702dedc67bca2fd45503c4.png";